import { createContext } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';

import { AssetIntegrationProviders } from '../assetProviderIntegrations/shared/constants';

export type BulkImportFlowType = Exclude<
  AssetIntegrationProviders,
  AssetIntegrationProviders.CSV_IMPORT
>;

export interface BulkImportFlowContextType {
  flowType: BulkImportFlowType;
}

export const BulkImportFlowContext = createContext<BulkImportFlowContextType>({
  flowType: AssetIntegrationProviders.ADDEPAR,
});

export const BulkImportFlowContextProvider = BulkImportFlowContext.Provider;

export const VALID_BULK_IMPORT_FLOW_TPYES = [
  AssetIntegrationProviders.ADDEPAR,
  AssetIntegrationProviders.BLACK_DIAMOND,
  AssetIntegrationProviders.ORION,
  AssetIntegrationProviders.EMONEY,
  AssetIntegrationProviders.SNOWFLAKE,
];

export function getBulkImportFlow(flowType: string): BulkImportFlowType {
  if (!VALID_BULK_IMPORT_FLOW_TPYES.includes(flowType as BulkImportFlowType)) {
    throw new Error('Invalid flow type');
  }
  return flowType as BulkImportFlowType;
}

export function useBulkImportFlowContext(): BulkImportFlowContextType {
  return useGuardedContext<BulkImportFlowContextType>(
    BulkImportFlowContext,
    'BulkImportFlowContextProivder'
  );
}
